import * as React from 'react';
import { 
    Button, 
    Col, 
    Panel, 
    Row 
} from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import DateTimeView from '../../../../../localDate/DateTimeView';
import { 
    BookableOrderTypes, 
    IBookingInfo, 
    NoBookingDecision,
    OrderTypes 
} from '../../Types';
import * as Features from '../../../../../../shared/Features';
import * as Site from '../../../../../../shared/Site';
import moment from 'moment';

type StylingOrderInfoProps = {
    bookingInfo: IBookingInfo;
    orderId: number;
    orderType: OrderTypes;
    site: string;
    user: any;
    markAsUnread: () => void;
    navigateTo: (url: string) => void;
    unbookStylingUser: () => void;
};

function StylingOrderInfo ({
    bookingInfo,
    orderId,
    orderType,
    site,
    user,
    markAsUnread,
    navigateTo,
    unbookStylingUser    
} : StylingOrderInfoProps) {

    const stylingBookingDecision = bookingInfo.stylingBookingDecision || NoBookingDecision;
    const goToBooking = () =>
        navigateTo(`${stylingBookingDecision.bookingPath}&redirectTo=/orders/${orderId}`);

return (
    <Col md={12} lg={6}>
                    <Panel>
                        <Panel.Heading>
                            {bookingInfo && (
                                <h3 className="panel-title">
                                    {Translate('view-order/basic-order-info/panel-headers/styling')}
                                </h3>
                            )}
                        </Panel.Heading>
                        <Panel.Body>
                            <dl>
                                <Row>
                                    <Col
                                        sm={
                                            (orderType & OrderTypes.bookable) !== 0
                                                ? 6
                                                : 12
                                        }
                                    >
                                        {bookingInfo && (
                                            <dt>
                                                {Translate(
                                                    'view-order/basic-order-info/titles/styling-status'
                                                )}
                                            </dt>
                                        )}
                                        <dd>
                                            {Translate(
                                                bookingInfo.stylingStatus.displayName
                                            )}
                                        </dd>
                                    </Col>
                                    {(orderType & OrderTypes.bookable) !== 0 && (
                                        <Col sm={6}>
                                            <dt>
                                                {Translate(
                                                    'view-order/basic-order-info/titles/booking-type'
                                                )}
                                            </dt>
                                            <dd>
                                                {Translate(
                                                    bookingInfo.bookingType.displayName
                                                )}
                                            </dd>
                                        </Col>
                                    )}
                                </Row>

                                <Row>
                                    {(orderType & OrderTypes.bookable) !== 0 &&
                                        bookingInfo.stylingUserName && (
                                            <Col sm={6}>
                                                <dt>
                                                    {bookingInfo &&
                                                        bookingInfo.bookableOrderType
                                                            .value === BookableOrderTypes.Styling &&
                                                        Translate(
                                                            'view-order/basic-order-info/titles/stylist'
                                                        )}
                                                </dt>
                                                <dd>
                                                    {bookingInfo &&
                                                        bookingInfo.bookableOrderType
                                                            .value ===
                                                            BookableOrderTypes.Styling && (
                                                            <i
                                                                style={{
                                                                    marginRight: '6px'
                                                                }}
                                                                className="material-icons"
                                                            >
                                                                style
                                                            </i>
                                                        )}

                                                    {(site === Site.getSiteName(Site.SE360) ||
                                                        Features.hasFeature(
                                                            Features.ViewBookedScandphotoPhotographerInfoRegardlessTime,
                                                            user
                                                        ) ||
                                                        (site === Site.getSiteName(Site.Scandphotos) &&
                                                            moment(
                                                                bookingInfo.bookedTime
                                                                    .localDateTime
                                                            ).diff(moment(), 'hours', true) <
                                                                24)) &&
                                                        bookingInfo.stylingUserName}

                                                    {site === Site.getSiteName(Site.Scandphotos) &&
                                                        !Features.hasFeature(
                                                            Features.ViewBookedScandphotoPhotographerInfoRegardlessTime,
                                                            user
                                                        ) &&
                                                        moment(
                                                            bookingInfo.bookedTime
                                                                .localDateTime
                                                        ).diff(moment(), 'hours', true) > 24 && (
                                                            <i className="blur">
                                                                {Translate(
                                                                    'view-order/basic-order-info/photographer/will-be-revealed'
                                                                )}
                                                            </i>
                                                        )}
                                                </dd>
                                            </Col>
                                        )}
                                </Row>

                                {(orderType & OrderTypes.bookable) !== 0 &&
                                    bookingInfo &&
                                    bookingInfo.bookableOrderType.value ===
                                        BookableOrderTypes.Photo && (
                                        <Row>
                                            <Col sm={6}>
                                                <dt>
                                                    {Translate(
                                                        'view-order/basic-order-info/titles/will-attend'
                                                    )}
                                                </dt>
                                                <dd>
                                                    {bookingInfo
                                                        .willOrderCreatorAttendWhenPhotographing ===
                                                    true
                                                        ? Translate(
                                                              'view-order/basic-order-info/label/will-attend/yes'
                                                          )
                                                        : Translate(
                                                              'view-order/basic-order-info/label/will-attend/no'
                                                          )}
                                                </dd>
                                            </Col>
                                            <Col sm={6}>
                                                <dt>
                                                    {Translate(
                                                        'view-order/basic-order-info/titles/number-of-images'
                                                    )}
                                                </dt>
                                                <dd>{bookingInfo.numberOfImages}</dd>
                                            </Col>
                                        </Row>
                                    )}

                                {(orderType & OrderTypes.bookable) !== 0 &&
                                    bookingInfo.preferredTimeOfPhotographing && (
                                        <div>
                                            <dt>
                                                {Translate(
                                                    'view-order/basic-order-info/titles/requested-time'
                                                )}
                                            </dt>
                                            <dd>
                                                {bookingInfo
                                                    .preferredTimeOfPhotographing ? (
                                                    <DateTimeView
                                                        dateTime={
                                                            bookingInfo
                                                                .preferredTimeOfPhotographing
                                                        }
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </dd>
                                        </div>
                                    )}
                                <Row>
                                    {(orderType & OrderTypes.bookable) !== 0 &&
                                        bookingInfo.bookedTime && (
                                            <Col sm={6}>
                                                <dt>
                                                    {Translate(
                                                        'view-order/basic-order-info/titles/booked-time'
                                                    )}
                                                </dt>
                                                <dd>
                                                    <DateTimeView
                                                        dateTime={
                                                            bookingInfo.bookedTime
                                                        }
                                                    />
                                                </dd>
                                            </Col>
                                        )}
                                    {(orderType & OrderTypes.bookable) !== 0 &&
                                        bookingInfo.bookedTime && (
                                            <Col sm={6}>
                                                <dt>
                                                    {Translate(
                                                        'view-order/basic-order-info/titles/calculated-end-time'
                                                    )}
                                                </dt>
                                                <dd>
                                                    <DateTimeView
                                                        dateTime={
                                                            bookingInfo
                                                                .calculatedEndTime
                                                        }
                                                    />
                                                </dd>
                                            </Col>
                                        )}
                                </Row>

                                {bookingInfo.keyPickupAddress ? (
                                    <div>
                                        <dt>{Translate('product-property/key-pickup')}</dt>
                                        <dd>
                                            <i style={{ marginRight: '6px' }} className="material-icons">
                                                vpn_key
                                            </i>
                                            {bookingInfo.keyPickupAddress}
                                            {bookingInfo.keyPickupZip || bookingInfo.keyPickupCity
                                                ? `, ${[bookingInfo.keyPickupZip, bookingInfo.keyPickupCity]
                                                      .filter(Boolean)
                                                      .join(' ')}`
                                                : null}
                                        </dd>
                                    </div>
                                ) : null}

                                {Features.hasFeature(
                                    Features.ViewNotes, 
                                    user
                                 ) && bookingInfo.notes ? (
                                    <dl>
                                        <dt>{Translate('view-order/basic-order-info/titles/notes')}</dt>
                                        <dd>{bookingInfo.notes}</dd>
                                    </dl>
                                ) : null}

                                {Features.hasFeature(
                                    Features.ViewCommentsToStylingUser, 
                                    user
                                 ) && bookingInfo.commentsToPhotographer && (
                                    <dl>
                                        <dt>
                                            {Translate('view-order/basic-order-info/titles/comments-to-stylinguser')}
                                        </dt>
                                        <dd>{bookingInfo.commentsToPhotographer}</dd>
                                    </dl>
                                )}

                                {!bookingInfo.isArchived &&
                                    Features.hasFeature(
                                        Features.MarkBookingOrderAsUnread,
                                        user
                                    ) && (
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => markAsUnread()}
                                        >
                                            {Translate(
                                                'view-order/basic-order-info/button/mark-as-unread'
                                            )}
                                        </Button>
                                    )}
                            </dl>
                            <div>
                                {stylingBookingDecision.canCancel && (
                                    <Button
                                        className="btn btn-danger"
                                        onClick={() => {
                                            unbookStylingUser();
                                        }}
                                    >
                                        {Translate('view-order/basic-order-info/button/unbook')}
                                    </Button>
                                )}
                                {stylingBookingDecision.canBook && (
                                    <Button className="btn btn-primary" onClick={goToBooking}>
                                        {Translate(
                                            bookingInfo.bookedTime
                                                ? 'view-order/basic-order-info/button/rebook'
                                                : 'view-order/basic-order-info/button/book'
                                        )}
                                    </Button>
                                )}
                            </div>
                        </Panel.Body>
                    </Panel>
                </Col>
);
}

export default StylingOrderInfo;
